import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import CenterModel from '../../../../components/ui/centerModel/CenterModel'
import Buttons from '../../../../components/ui/button/Buttons'
import FormCreator from '../../../../components/Forms/FormCreator'
import { AddKeypositionData } from './KeyPositions.data'
import { useAddCorporateRepresentativeKeyPositionInformationMutation, useLazyGetAllKeyPositionsDetailByCorporateMemberIdQuery, useLazyGetCorporateRepresentativeInformationByIdQuery } from '../../../../app/services/corporateMembership/corporateMemberApi'
import ToastService from '../../../../services/toastService/ToastService'
import SwalAlert from '../../../../services/swalService/SwalService'
import { setAllDropDownFieldForViewMember } from '../../utils/dropdownUtils'
import { useAddSGBCCorporateRepresentativeLogMutation, useLazyDeleteCorporateKeyPositionByIdQuery, useLazySearchByEmailForKeyPositionQuery } from '../../../../app/services/Employees/employeeApi'
import { getAuthProps } from '../../../../lib/authenticationLibrary'

const withSearchButtonBound = (form, onSearch, isLoading) => ({
  ...form,
  formFields: form.formFields.map((field) => {
    if (field.id !== "searchEmailButton") return field;
    return {
      ...field,
      additionalComponent: (
        <Buttons
          onClick={onSearch}
          buttonText="Search"
          buttonTypeClassName="success-btn d-block"
          isLoading={isLoading}
          isDisable={isLoading}
        />
      ),
    };
  }),
});

const KeyPositions = ({ id, setIsEmployee, dropDownList,roleId }) => {
  const keyPositionsRef = useRef();
  let roleLimits = {
    1: 1, // Official Management Representative
    2: 1, // Assistant to Management Representative
    3: 2, // Corporate Administrator
    4: 2, // Chief Sustainability Officer or equivalent
    5: Infinity, // Certification Coordinator
  };
  const { error, success, confirm } = SwalAlert();
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false);
  const [formData, setFormData] = useState(AddKeypositionData)
  const [memberList, setMeberList] = useState([])
  const [showAll, setShowAll] = useState(false);
  const [visibleList, setVisibleList] = useState([]);
  const [sGBCCorporateRepresentativeId, setSGBCCorporateRepresentativeId] = useState(0);
  const [isDropdownReady, setIsDropdownReady] = useState(false);
  let authData = getAuthProps();
  const pendingLogRef = useRef(null);

  const [getAllKeyPositionsDetailByCorporateMemberId, { isLoading: keyPositionDetailIsLoading, isSuccess: keyPositionDetailIsSuccess, data: keyPositionDetailResponse }] = useLazyGetAllKeyPositionsDetailByCorporateMemberIdQuery();
  const [addCorporateRepresentativeKeyPositionInformation, { isSuccess: addCorporateRepresentativeKeyPositionInformationIsSuccess, isLoading: addCorporateRepresentativeKeyPositionInformationIsLoading, data: addCorporateRepresentativeKeyPositionInformationData }] = useAddCorporateRepresentativeKeyPositionInformationMutation();
  const [getCorporateRepresentativeInformationById, { isLoading: corporateRepresentativeDetailIsLoading, isSuccess: corporateRepresentativeDetailIsSuccess, data: corporateRepresentativeDetailResponse }] = useLazyGetCorporateRepresentativeInformationByIdQuery();
  const [deleteCorporateKeyPosition, { isSuccess: deleteCorporateKeyPositionIsSuccess, isLoading: deleteCorporateKeyPositionIsLoading, data: deleteCorporateKeyPositionData, isError: deleteCorporateKeyPositionError, },] = useLazyDeleteCorporateKeyPositionByIdQuery();
  const [searchByEmailForKeyPosition, { isLoading: searchByEmailForKeyPositionIsLoading }] = useLazySearchByEmailForKeyPositionQuery();
  const [addRepresentativeLog] = useAddSGBCCorporateRepresentativeLogMutation();

  const saveLog = (actionType, message, representativeId) => {
    addRepresentativeLog({
      sgbcCorporateMemberId: id,
      sgbcCorporateRepresentativeId: representativeId || null,
      actionType,                // "Add" | "Update" | "Delete"
      message,
      createdBy: authData.userName,
    });
  };

  const phoneFieldMap = {
    mobileNumberCountryId: "mobileNumber",
    contactNumberCountryId: "contactNumber",
  };

  const applySearchResult = useCallback((responseData, email) => {
    setFormData((prev) => {
      if (responseData?.hasError === "No record found for this email.") {
        ToastService.error("No record found for this email.");
        return {
          ...prev,
          initialState: {
            ...prev.initialState,
            searchEmailAddress: "",
            corporateRoleId: null,
            salutationId: null,
            firstName: "",
            lastName: "",
            designation: "",
            email,
            jobLevelId: null,
            jobFunctionId: null,
            mobileNumberCountryId: null,
            mobileNumber: "",
            contactNumberCountryId: null,
            contactNumber: "",
          },
          formFields: prev.formFields.map((field) => {
            if (field.id === "email") {
              return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: true } };
            }
            if (field.id === "searchEmailAddress") {
              return { ...field, validation: [] };
            }
            if (field.id === "searchEmailButton") return field;
            return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: false } };
          }),
        };
      }

      return {
        ...prev,
        initialState: {
          ...prev.initialState,
          searchEmailAddress: "",
          salutationId: responseData?.salutationId || null,
          firstName: responseData?.firstName || null,
          lastName: responseData?.lastName || null,
          designation: responseData?.designation || null,
          email: responseData?.email || null,
          jobLevelId: responseData?.jobLevelId || null,
          jobFunctionId: responseData?.jobFunctionId || null,
          mobileNumberCountryId: responseData?.mobileNumberCountryId || null,
          mobileNumber: responseData?.mobileNumber || null,
          contactNumberCountryId: responseData?.contactNumberCountryId || null,
          contactNumber: responseData?.contactNumber || null,
        },
        formFields: prev.formFields.map((field) => {
          if (field.id === "searchEmailAddress") return { ...field, validation: [] };
          if (field.id === "corporateRoleId") {
            return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: false } };
          }
          if (field.id === "email") {
            return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: true } };
          }
          if (field.id === "searchEmailButton") return field;
          return { ...field, fieldSetting: { ...field.fieldSetting, isDisable: false } };
        }),
      };
    });
  }, []);

  // search email
  const handleEmailSearch = useCallback(async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const email = keyPositionsRef?.current?.getFieldValue("searchEmailAddress");
    if (!email) return;
    if (!emailRegex.test(email)) return;
    if (!(id > 0)) return;

    try {
      const result = await searchByEmailForKeyPosition({ MemberId: id, Email: email }).unwrap();
      applySearchResult(result, email);
    } catch (err) {
      ToastService.error("Something went wrong while searching. Please try again.");
    }
  }, [id, searchByEmailForKeyPosition, applySearchResult]);

  useEffect(() => {
    if (!addCorporateRepresentativeKeyPositionInformationIsLoading && addCorporateRepresentativeKeyPositionInformationIsSuccess && addCorporateRepresentativeKeyPositionInformationData) {
      if (addCorporateRepresentativeKeyPositionInformationData?.errorMessage === "The account already exist with same role") {
        ToastService.warning("The account already exist with same role.", "Unsuccessful");
      }
      else {
        if (pendingLogRef.current) {
          const { actionType, message, representativeId } = pendingLogRef.current;
          saveLog(actionType, message, representativeId || addCorporateRepresentativeKeyPositionInformationData?.id);
          pendingLogRef.current = null;
        }
        const isUpdateMsg = addCorporateRepresentativeKeyPositionInformationData?.errorMessage === "Updated";
        success(isUpdateMsg ? "Representative has been Updated successfully." : "Representative has been added successfully.", "Successful");
        setSGBCCorporateRepresentativeId(0);
        handleClear();
        setIsOpenModal(false);
        setIsEmployee(true);
        setIsDropdownReady(false);
        getAllKeyPositionsDetailByCorporateMemberId(id).unwrap()
          .then(() => setIsDropdownReady(true))
          .catch(() => setIsDropdownReady(true));
      }
    }
  }, [addCorporateRepresentativeKeyPositionInformationIsLoading, addCorporateRepresentativeKeyPositionInformationIsSuccess, addCorporateRepresentativeKeyPositionInformationData]);

  useEffect(() => {
    if (!deleteCorporateKeyPositionIsLoading && deleteCorporateKeyPositionData && deleteCorporateKeyPositionIsSuccess) {
      getAllKeyPositionsDetailByCorporateMemberId(id);
      setIsEmployee(true);
      if (pendingLogRef.current) {
        const { actionType, message, representativeId } = pendingLogRef.current;
        saveLog(actionType, message, representativeId);
        pendingLogRef.current = null;
      }
    }
  }, [deleteCorporateKeyPositionIsLoading, deleteCorporateKeyPositionData, deleteCorporateKeyPositionIsSuccess])

  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    if (["mobileNumber", "contactNumber"].includes(dataField)) {
      const updatedInitialState = { ...form.initialState, [dataField]: value.replace(/\D/g, "") }
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    }
    else if (Object.keys(phoneFieldMap).includes(dataField)) {
      const updatedFormFields = form.formFields.map((field) => {
        if (field.id === dataField) {
          return { ...field, fieldSetting: { ...field.fieldSetting }, };
        }
        return field;
      });
      const updatedInitialState = { ...form.initialState, [dataField]: value?.value || "", };
      setFormData((prev) => ({ ...prev, formFields: updatedFormFields, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    } else {
      setFormData((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  }

  const handleDeleteClick = (data) => {
    confirm('Delete?', 'Are you sure you want to delete this employee?', 'Delete', 'Cancel').then((confirmed) => {
      if (!confirmed) return;
      deleteCorporateKeyPosition(data?.sgbcCorporateRepresentativeId).unwrap()
        .then(() => {
          saveLog(
            "Delete",
            `Deleted key representative ${data?.fullName} (${data?.email}) - role: ${data?.corporateRole}`,
            data?.sgbcCorporateRepresentativeId
          );
        })
        .catch(() => {});
    });
  };

  const sanitizeIdValue = (val) => {
    if (val === 0 || val === '0' || val === '' || val === undefined) return null;
      return val;
    };

    const handleViewProfileClick = (position) => {
    if (!isDropdownReady) return;
    if (!position.sgbcCorporateRepresentativeId) return;

    const fieldsToDisable = ['corporateRoleId', 'email'];
    const fieldsToHide = ['searchEmailAddress', 'searchEmailButton'];

    const viewOnlyForm = {
      ...AddKeypositionData,
      formFields: AddKeypositionData.formFields
        .filter(field => !fieldsToHide.includes(field.id))
        .map(field => ({
          ...field,
          fieldSetting: {
            ...field.fieldSetting,
            isDisable: fieldsToDisable.includes(field.id),
          },
        })),
    };

    setSGBCCorporateRepresentativeId(position?.sgbcCorporateRepresentativeId);
    setFormData(viewOnlyForm);
    setIsUpdate(true);
    setIsOpenModal(true);

    loadRepresentativeDetails(position.sgbcCorporateRepresentativeId, (updatedDetails) => {
      const idFields = ['salutationId', 'jobLevelId', 'jobFunctionId', 'mobileNumberCountryId', 'contactNumberCountryId', 'corporateRoleId'];
      const cleanedDetails = { ...updatedDetails };
      idFields.forEach((key) => {
        if (key in cleanedDetails) cleanedDetails[key] = sanitizeIdValue(cleanedDetails[key]);
      });

      const updatedForm = {
        ...viewOnlyForm,
        initialState: { ...viewOnlyForm.initialState, ...cleanedDetails },
      };
      setFormData(updatedForm);
    });
  };

  const loadRepresentativeDetails = async (representativeId, updateFormCallback) => {
    try {
      const data = await getCorporateRepresentativeInformationById(representativeId).unwrap();
      const updatedDetails = {
        ...data,
        corporateRoleId: data?.corporateRoleId ? Number(data?.corporateRoleId) : 0
      };

      updateFormCallback(updatedDetails);
    } catch (err) {
      error("Failed to load representative details. Please try again.");
    }
  };

  const handleClear = () => {
    setFormData({ ...AddKeypositionData });
  }

  const handleSubmit = () => {
    const formDetails = keyPositionsRef?.current.getFormData();
    if (!formDetails) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }

    const maxLimit = {
      "Official Management Representative": 1,
      "Assistant to Management Representative": 1,
      "Corporate Administrator": 2,
      "Chief Sustainability Officer or equivalent": 2,
      "Certification Coordinator": Infinity,
    };

    const roleField = formData.formFields.find(f => f.id === "corporateRoleId");
    const roleOptions = roleField?.fieldSetting?.options || [];

    const selectedRole = roleOptions.find(
      opt => opt.value === (formDetails?.corporateRoleId?.value || formDetails?.corporateRoleId)
    );

    if (!selectedRole) {
      return ToastService.error("Please select a role.");
    }

    const selectedRoleLabel = selectedRole.label;

    const existingCount = keyPositionDetailResponse.filter(
      x => x.corporateRole?.trim() === selectedRoleLabel
    ).length;

    const limit = maxLimit[selectedRoleLabel] ?? Infinity;

    const isEdit = sGBCCorporateRepresentativeId > 0;

    if (!isEdit && existingCount >= limit) {
      return ToastService.error(
        `${selectedRoleLabel} role has reached its maximum limit.`
      );
    }

    const representativeDetailObjReq = {
      sgbcCorporateMemberId: id || null,
      corporateRoleId: selectedRole?.value ? String(selectedRole.value) : null,
      salutationId: formDetails.salutationId?.value || formDetails.salutationId,
      firstName: formDetails.firstName || null,
      lastName: formDetails.lastName || null,
      designation: formDetails.designation || null,
      email: formDetails.email || null,
      jobLevelId: formDetails?.jobLevelId?.value || formDetails?.jobLevelId,
      jobFunctionId: formDetails?.jobFunctionId?.value || formDetails?.jobFunctionId,
      mobileNumberCountryId: formDetails?.mobileNumberCountryId?.value || formDetails?.mobileNumberCountryId,
      mobileNumber: formDetails.mobileNumber || null,
      contactNumberCountryId: formDetails?.contactNumberCountryId?.value || formDetails?.contactNumberCountryId,
      contactNumber: formDetails.contactNumber || null,
      sgbcCorporateRepresentativeId: sGBCCorporateRepresentativeId || null,
      isCopiedFromMembership: false,
      isSameEmail: false
    };
    if (representativeDetailObjReq.sgbcCorporateMemberId > 0) {
      debugger;
      const fullName = `${formDetails.firstName || ""} ${formDetails.lastName || ""}`.trim();
      pendingLogRef.current = { actionType: isEdit ? "Update" : "Add", message: isEdit ? `Updated key representative ${fullName} (${formDetails.email}) - role: ${selectedRoleLabel}`: `Added key representative ${fullName} (${formDetails.email}) - role: ${selectedRoleLabel}`,
      representativeId: sGBCCorporateRepresentativeId || null,};
      addCorporateRepresentativeKeyPositionInformation(representativeDetailObjReq);
    }
  };

  useEffect(() => {
    if (id) {
      getAllKeyPositionsDetailByCorporateMemberId(id)
    }
  }, [])

  const disabledRoles = useMemo(() => {
    if (!keyPositionDetailResponse) return [];

    const roleCounts = {};
    keyPositionDetailResponse.forEach((item) => {
      const roleId = item?.sgbcCorporateRoleId;
      roleCounts[roleId] = (roleCounts[roleId] || 0) + 1;
    });

    return (dropDownList || [])
      .filter((item) => item.dropdownName === "Roles")
      .map((role) => {
        const count = roleCounts[role.id] || 0;
        const maxLimit = roleLimits[role.id];
        return {
          ...role,
          isDisabled: count >= maxLimit,
          dropdownName: "Role with limit",
        };
      });
  }, [dropDownList, keyPositionDetailResponse]);

  useEffect(() => {
    if (!keyPositionDetailResponse) return;
    if (!dropDownList || dropDownList.length === 0) return;
    setAllDropDownFieldForViewMember([...dropDownList, ...disabledRoles]);
    setMeberList(keyPositionDetailResponse);
    setIsDropdownReady(true);
  }, [dropDownList, keyPositionDetailResponse, disabledRoles]);

  useEffect(() => {
    if (showAll) {
      setVisibleList(memberList);
    } else {
      setVisibleList(memberList?.slice(0, Infinity));
    }
  }, [memberList, showAll]);

  const buttonClick = () => {
    if (!isDropdownReady) return;
    setIsOpenModal(!isOpenModal)
    setIsUpdate(false)
    handleClear()
  }

  const handleCloseModal = () => {
    setIsOpenModal(false)
    setSGBCCorporateRepresentativeId(0)
    setIsUpdate(false);
    handleClear();
  }

  const boundFormData = withSearchButtonBound(formData, handleEmailSearch, searchByEmailForKeyPositionIsLoading);

  return (
    <>
      <Accordion title="Membership Management" buttonLabel={"+ Add New Profile"} clickEvent={buttonClick} isDisable={roleId === 12}>
        <div className="team-table-container">
          <table className="team-table key-position-table">
            <tbody>
              {(showAll ? memberList : memberList?.slice(0, 5))?.map((member, index) => (
                <tr key={index}>
                  <td className="name-cell">{member?.fullName}</td>
                  <td className="role-cell">{member?.corporateRole}</td>
                  <td className="edit-cell">
                    <Buttons
                      buttonText="Edit Profile"
                      buttonTypeClassName="edit-link"
                      onClick={() => handleViewProfileClick(member)}
                      isDisable={roleId === 12}
                    />
                    <span className="divider">|</span>
                    <Buttons
                      buttonText="Delete"
                      buttonTypeClassName="delete-link"
                      onClick={() => handleDeleteClick(member)}
                      isDisable={roleId === 12}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {memberList?.length > 5 && (
            <div
              className="load-more-btn"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? "Load Less" : "Load More"}
            </div>
          )}
        </div>
      </Accordion>

      {
        isOpenModal && <CenterModel
          show={isOpenModal}
          handleClose={handleCloseModal}
          modelTitle={`${isUpdate ? "Update Profile" : "New Profile"}`}
        >
          <div className="row">
            <FormCreator
              ref={keyPositionsRef}
              {...boundFormData}
              onFormFieldValueChange={handleFormFieldChange}
            />
          </div>
          <Buttons
            buttonText={`${isUpdate ? "Update Key Position" : "Add Key Position"}`}
            buttonTypeClassName="success-btn d-block ml-auto"
            onClick={() => handleSubmit()}
            isLoading={addCorporateRepresentativeKeyPositionInformationIsLoading}
            isDisable={addCorporateRepresentativeKeyPositionInformationIsLoading || roleId === 12}
          />
        </CenterModel>
      }
    </>
  )
}

export default KeyPositions